const back_arrow = require("../assets/Images/Icons/Back-Arrow.png");
const google_icon = require("../assets/Images/Icons/google_icon.png");
const facebook_icon = require("../assets/Images/Icons/facebook_icon.png");
const twitter_icon = require("../assets/Images/Icons/twitter_icon.png");
const facebook = require("../assets/Images/Icons/facebook.png");
const twitter = require("../assets/Images/Icons/twitter.png");
const youtube = require("../assets/Images/Icons/youtube.png");
const linkdin = require("../assets/Images/Icons/linkdin.png");
const instagram = require("../assets/Images/Icons/instagram.png");
const rocket_icon = require("../assets/Images/Icons/rocket_icon.png");
const database_icon = require("../assets/Images/Icons/database_icon.png");
const leafe_icon = require("../assets/Images/Icons/leafe_icon.png");
const profile_icon = require("../assets/Images/Icons/profile_icon.png");

const logo_white = require("../assets/Images/logo_white.png");
const logo_blue = require("../assets/Images/logo_blue.png");
const bg_image = require("../assets/Images/bg-ep.jpg");
const camera_image = require("../assets/Images/camera_image.png");
const home_image = require("../assets/Images/home_image.png");
const sit_laptop = require("../assets/Images/sit_laptop.png");
const camera = require("../assets/Images/camera.png");
const image_1 = require("../assets/Images/image_1.png");
const image_2 = require("../assets/Images/image_2.png");
const image_3 = require("../assets/Images/image_3.png");
const image_4 = require("../assets/Images/image_4.png");
const image_5 = require("../assets/Images/image_5.png");
const image_6 = require("../assets/Images/image_6.png");
const image_7 = require("../assets/Images/image_7.png");
const menu = require("../assets/Images/Icons/menu.png");
const inbox = require("../assets/Images/Icons/inbox.png");
const user = require("../assets/Images/Icons/user.png");
const placeholder = require("../assets/Images/placeholder.png");
const image_cat = require("../assets/Images/image_cat.png");
const list = require("../assets/Images/Icons/list.png");
const grid = require("../assets/Images/Icons/grid.png");
const location = require("../assets/Images/Icons/location.png");
const filmy = require("../assets/Images/filmy.png");
const audio = require("../assets/Images/audio.png");
const projector = require("../assets/Images/projector.png");
const drones = require("../assets/Images/drones.png");
const dj = require("../assets/Images/dj.png");
const transport = require("../assets/Images/transport.png");
const storage = require("../assets/Images/storage.png");
const electronics = require("../assets/Images/electronics.png");
const party = require("../assets/Images/party.png");
const sports = require("../assets/Images/sports.png");
const music = require("../assets/Images/music.png");
const home = require("../assets/Images/home.png");
const kids = require("../assets/Images/kids.png");
const holiday = require("../assets/Images/holiday.png");
const clothing = require("../assets/Images/clothing.png");
const uploadIconImg = require("../assets/Images/uploadIconImg.png");

const ArrowNew = require("../assets/Images/ArrowNew.png");
const productImg = require("../assets/Images/productImg.png");
const locationIcon = require("../assets/Images/Icons/locationIcon.png");
const elephentblue = require("../assets/Images/Icons/elephentblue.png");
const locatate = require("../assets/Images/Icons/locatate.png");
const ratingIcon = require("../assets/Images/Icons/ratingIcon.png");
const MapImg = require("../assets/Images/MapImg.png");
const withDraw = require("../assets/Images/withdraw.png");
const profileImage = require("../assets/Images/profileImg.png");
const uploadArrow = require("../assets/Images/uploadArrow.png");
const statistics = require("../assets/Images/statistics.png");
const listFill = require("../assets/Images/Icons/list-fill.png");
const gridFill = require("../assets/Images/Icons/grid-fill.png");
const locationFill = require("../assets/Images/Icons/location-fill.png");
const information_button = require("../assets/Images/Icons/information-button.png");
const uploadSubImg = require("../assets/Images/Icons/uploadSubImg.png");
const close = require("../assets/Images/Icons/close.png");
const confirm = require("../assets/Images/Icons/confirm.png");
const search = require("../assets/Images/Icons/search.png");
const aim = require("../assets/Images/Icons/aim.png");
const audioVis = require("../assets/Images/Icons/audio.png");
const cameraVis = require("../assets/Images/Icons/camera-i.png");
const projectorVis = require("../assets/Images/Icons/projector.png");
const dronesVis = require("../assets/Images/Icons/drone.png");
const djVis = require("../assets/Images/Icons/dj.png");
const transportVis = require("../assets/Images/Icons/transport.png");
const storageVis = require("../assets/Images/Icons/storage.png");
const electronicsVis = require("../assets/Images/Icons/electronics.png");
const partyVis = require("../assets/Images/Icons/party.png");
const sportsVis = require("../assets/Images/Icons/sports.png");
const musicVis = require("../assets/Images/Icons/music.png");
const homeVis = require("../assets/Images/Icons/home.png");
const kidsVis = require("../assets/Images/Icons/kids.png");
const holidayVis = require("../assets/Images/Icons/holiday.png");
const clothingVis = require("../assets/Images/Icons/clothing.png");
const sendMsgIcon = require("../assets/Images/Icons/sendMsgIcon.png");
const dotIconNew = require("../assets/Images/Icons/3dotIcon.png");
const camera1new = require("../assets/Images/camera1new.jpg");
const r1 = require("../assets/Images/r1.png");
const r2 = require("../assets/Images/r2.png");
const r3 = require("../assets/Images/r3.png");
const r4 = require("../assets/Images/r4.png");
const l1 = require("../assets/Images/l1.png");
const l2 = require("../assets/Images/l2.png");

export default {
  r1,
  r2,
  r3,
  r4,
  l1,
  l2,
  cameraVis,
  projectorVis,
  dronesVis,
  djVis,
  transportVis,
  storageVis,
  electronicsVis,
  partyVis,
  sportsVis,
  musicVis,
  homeVis,
  kidsVis,
  holidayVis,
  clothingVis,
  audioVis,
  search,
  aim,
  confirm,
  close,
  listFill,
  gridFill,
  locationFill,
  filmy,
  audio,
  projector,
  drones,
  dj,
  transport,
  storage,
  electronics,
  party,
  sports,
  music,
  home,
  kids,
  holiday,
  clothing,
  location,
  grid,
  list,
  image_cat,
  placeholder,
  inbox,
  user,
  back_arrow,
  logo_white,
  google_icon,
  facebook_icon,
  twitter_icon,
  bg_image,
  logo_blue,
  facebook,
  twitter,
  youtube,
  linkdin,
  instagram,
  camera_image,
  rocket_icon,
  database_icon,
  leafe_icon,
  home_image,
  sit_laptop,
  camera,
  image_1,
  image_2,
  image_3,
  image_4,
  image_5,
  image_6,
  profile_icon,
  image_7,
  menu,
  ArrowNew,
  productImg,
  locationIcon,
  elephentblue,
  locatate,
  ratingIcon,
  MapImg,
  withDraw,
  profileImage,
  uploadArrow,
  statistics,
  information_button,
  uploadSubImg,
  uploadIconImg,
  sendMsgIcon,
  dotIconNew,
  camera1new,
};
